<template>
  <div>
    <div
      class="dashboard-head d-flex align-items-center border-bottom pb-2 mb-3"
      v-if="!errorMessage"
    >
      <h1 class="h2">
        <span class="text-danger">Тест {{ current.id }}</span
        >. {{ typeDataTitle }}. {{ subjectDataTitle }} - Результаты
      </h1>
    </div>
    <div class="dashboard-body py-2">
      <b-overlay
        :show="loader"
        rounded="sm"
        variant="white"
        opacity=".85"
        blur="4px"
      >
        <div class="question-info">
          <div class="question-info__dot question-info__dot--success"></div>
          <div class="question-info__text">Правильно</div>
          <div class="question-info__point">Ваш балл: {{ point }}/100</div>
          <div class="question-info__dot question-info__dot--danger"></div>
          <div class="question-info__text">Неправильно</div>
        </div>

        <div class="result-items">
          <div
            class="result-item"
            v-for="(q, index) in current.questions"
            :key="index"
            :class="{ correct: isCorrectCard(q) }"
          >
            <div class="result-item__content">
              <div class="result-item__title">{{ q.text }}</div>
              <div class="result-item-correct result-item__correct">
                <div class="result-item-correct__label">Правильный ответ:</div>
                <div class="result-item-correct__text" v-if="q.type === 20">
                  {{ q.answers[0].text }}
                </div>
                <div class="result-item-correct__text" v-if="q.type === 10">
                  {{ correctAnswer(q).text }}
                </div>
              </div>
              <div class="result-item__answ">
                Ваш ответ: {{ userAnswer(q) }}
              </div>
            </div>
            <div class="result-item__point">
              <div class="result-item__point-label">Балл:</div>
              <div class="result-item__point-value">{{ q.point }}</div>
            </div>
          </div>
        </div>

        <b-alert variant="warning" :show="hasError">
          {{ errorMessage }}
        </b-alert>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import msg from '@/utils/messages';
// import Latex from '@/components/exam/Latex';

export default {
  components: {
    // Latex
  },
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_EXAM_RESULT + ' №' + this.$route.params.id,
      titleTemplate: `${this.siteName || ''} - %s`
    };
  },
  data() {
    return {
      loader: true,
      hasError: false,
      errorMessage: false,
      userAnswers: [],
      answers: null,
      userExam: null,
      current: [],
      correct: []
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    typeDataTitle() {
      return this.current.typeData?.title;
    },
    subjectDataTitle() {
      return this.current.subjectData?.title;
    },
    point() {
      return this.userExam?.point;
    },
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  },
  methods: {
    reRender() {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    },
    getCorrectAnswer(q) {
      //поиск правильного ответа относительно списка ответов пользователя
      return q.answers.find(el => {
        return el.id === this.userAnswers[q.id].a && el.correct === 10;
      });
    },
    isCorrectCard(q) {
      const correctAnswer = this.correctAnswer(q);
      if (q.type === 20) {
        return correctAnswer.text === this.userAnswers[q.id]?.value;
      } else {
        return correctAnswer.id === this.userAnswers[q.id]?.a;
      }
    },
    correctAnswer(q) {
      //поиск правильного ответа из общего списка
      return q.answers.find(el => {
        return el.correct === 10;
      });
    },
    userAnswer(q) {
      return this.userAnswers[q.id]
        ? this.answers[this.userAnswers[q.id].value]
        : 'нет ответа';
    }
  },
  async mounted() {
    this.errorMessage = false;
    try {
      const id = this.$route.params.id;
      const data = await this.$store.dispatch('examDetail', id);
      const userExam = await this.$store.dispatch('examView', id);

      this.userExam = userExam.model;
      this.answers = userExam.allAnswers;
      this.userAnswers = userExam.model.answers;
      this.current = data;
      this.loader = false;
      this.hasError = false;
      setTimeout(() => this.reRender(), 0);
    } catch (e) {
      this.errorMessage = e.response.data.message;
      this.hasError = true;
      this.loader = false;
      console.log(e.response.data.message);
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/_mixins/media';
.question-info {
  display: grid;
  grid-template: repeat(2, 25px) / 25px 1fr auto;
  grid-gap: 5px;
  margin-bottom: 15px;

  &__dot {
    border-radius: 50%;

    &--danger {
      background-color: #eb5757;
    }
    &--success {
      background-color: #27ae60;
    }
  }

  &__point {
    font-weight: 700;
  }
}

.result-items .result-item {
  margin-bottom: 15px;
}

.result-item {
  --color-red: #eb5757;
  --color-green: #27ae60;

  background-color: #eef0f3;
  padding: 20px 0 20px 45px;
  border-radius: 7px;
  line-height: 1.2;
  position: relative;
  overflow: hidden;
  display: flex;

  @include media(580, true) {
    padding: 20px 0 20px 35px;
  }

  svg {
    max-width: 100%;
  }

  &__title {
    font-size: 24px;
    margin-bottom: 15px;

    @include media(580, true) {
      font-size: 18px;
    }
  }
  &__correct {
    margin-bottom: 7px;
  }

  &__content {
    padding-right: 15px;
    flex-grow: 1;
  }

  &__point {
    padding: 20px 30px 20px 30px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-left: 1px solid #e0e0e0;
    color: var(--color-red);

    @include media(580, true) {
      padding: 20px 10px 20px 10px;
    }

    &-label {
      font-size: 14px;
      font-weight: 400;
    }
    &-value {
      font-size: 20px;
      font-weight: 700;
    }
  }

  &::before {
    content: '';
    display: block;
    width: 15px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
    background: var(--color-red);
  }

  &.incorrect {
    &::before {
      background-color: var(--color-red);
    }
    .result-item__point {
      color: var(--color-red);
    }
  }
  &.correct {
    &::before {
      background-color: var(--color-green);
    }
    .result-item__point {
      color: var(--color-green);
    }
  }
}
.result-item-correct {
  padding: 5px 12px;
  background-color: #fff;
  color: var(--dark);
  border-radius: 4px;

  &__label {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 5px;
    color: #bdbdbd;
  }
  &__text {
    font-size: 16px;
    margin-bottom: 5px;
  }
}
</style>
